import React from 'react'
import useSeo from '../../hooks/useSeo.ts'

const TermsAndConditions = () => {
	useSeo({ title: 'Terms & Conditions | Wedding Camera', description: 'Wedding Camera terms & conditions.', path: '/terms-and-conditions', lang: 'en' })
	return (
		<div style={{ fontFamily: 'Arial, sans-serif', lineHeight: '1.6', color: '#333', padding: '20px' }}>
			<h1 style={{ color: '#444' }}>Terms & Conditions</h1>
			<p><strong>Last updated:</strong> 27.12.2024</p>

			<h2 style={{ color: '#444' }}>Introduction</h2>
			<p>Welcome to Wedding Camera. By using this application, you agree to the following Terms & Conditions.</p>

			<h2 style={{ color: '#444' }}>Eligibility</h2>
			<ul>
				<li>You must be at least 18 years old or have parental consent to use the Application.</li>
				<li>By uploading photos, you confirm that you own or have the rights to share the content.</li>
			</ul>

			<h2 style={{ color: '#444' }}>Acceptable Use Policy</h2>
			<p>You agree not to upload content that:</p>
			<ul>
				<li>Contains nudity, violence, or offensive material.</li>
				<li>Violates copyright or intellectual property laws.</li>
			</ul>

			<h2 style={{ color: '#444' }}>Content Moderation</h2>
			<ul>
				<li>All uploaded photos are subject to manual review. Inappropriate content will be removed, and repeat offenders may have their accounts suspended.</li>
			</ul>

			<h2 style={{ color: '#444' }}>Liability</h2>
			<ul>
				<li>Wedding Camera is not liable for content uploaded by users. Users are solely responsible for their uploaded content.</li>
			</ul>

			<h2 style={{ color: '#444' }}>Changes to These Terms</h2>
			<p>We may update these Terms at any time. Continued use of the Application implies acceptance of the updated Terms.</p>

			<h2 style={{ color: '#444' }}>Contact Us</h2>
			<p>For questions or concerns, email us at <a href="mailto:hello@mcode.hr" style={{ color: '#007BFF', textDecoration: 'none' }}>hello@mcode.hr</a>.</p>
		</div>
	)
}

export default TermsAndConditions
